<div class="orange-ramadan20-footer">
  <a href="https://www.gbarena.com" target="_blank" class="gbarena">
    <img src="assets/img/GBarena-type.svg" style="width: 80px" alt="GBarena Logo">
  </a>
  <p>Orange Ramadan Cup is organize by
    <a href="https://www.gbarena.com/arena/arabharwdare/summary" target="_blank">ArabHardware</a>
     powered by   <a href="http://www.victorylink.com/">Victory Link</a>
    <br>
   This page is hosted on GBarena, All <a href="https://www.gbarena.com/privacy" target="_blank">
     Terms & Conditions Apply
    </a>
  </p>
  <span>
        <a href="mailto:mail@gbarena.com" target="_blank"><i class="icon-mail-alt" style="font-size:18px;"></i></a>
    <a href="https://facebook.com/gbarena" target="_blank"><i class="icon-facebook-circled"></i></a>
    <a href="https://twitter.com/gbarenaofficial" target="_blank"><i class="icon-twitter-circled"></i></a>
    <a href="https://www.instagram.com/gbarenaofficial" target="_blank"><i  class="icon-instagram-circled"></i></a>
    <a href="https://discord.gg/4r43M4r" target="_blank">
      <img src="assets/img/icons/discord-logo-white.svg" width="15" style="margin: 0 5px 5px 5px;" alt="">
    </a>
  </span>
</div>